import Albums from '@/components/albums';

export default function Musicbox({albums, singles}) {
    return (
        <div className="flex flex-wrap gap-8 p-8">
            <div className='flex basis-full lg:basis-4xl flex-col'>
                <span className="py-6 text-xl font-bold uppercase">Albums</span>
                <Albums albums={albums}/>
            </div>
            <div className="flex flex-1 flex-col min-w-50">
                <span className="py-6 text-xl font-bold uppercase">
                    singles
                </span>
                <div className="flex flex-1 items-start">
                    <div className="flex flex-col">
                        <Albums albums={singles} className='lg:grid-cols-2' />
                    </div>
                </div>
            </div>
        </div>
    );
}
